import { brand } from '@/config/brands'

/**
 * Setting 页面样式配置
 * 根据品牌返回不同的样式
 */

const defaultStyles = {
  cardPaddingX: '',
  pageMarginX: 'mx-10px',
}

const brandStyles: Record<string, Partial<typeof defaultStyles>> = {
  novelarc: {
    pageMarginX: 'mx-10px',
  },
  storyella: {
    pageMarginX: 'mx-10px',
  },
  marinovel: {
    cardPaddingX: 'px-16px',
  },
}

export const settingStyles = {
  ...defaultStyles,
  ...brandStyles[brand],
}
